import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../assets/styles/styleUser.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import AuthService from "../../services/AuthServices";
import BraidsForm from "../../components/BraidsForm";
import { toast } from "react-toastify";
import video1 from "../../assets/video/1.MP4";
import video2 from "../../assets/video/2.MP4";
import video3 from "../../assets/video/3.MP4";
import video4 from "../../assets/video/4.MP4";
import img1 from "../../assets/images/1.JPG";
import img2 from "../../assets/images/2.JPG";
import img3 from "../../assets/images/3.JPG";
import img4 from "../../assets/images/4.JPG";
import img5 from "../../assets/images/5.JPG";
import img6 from "../../assets/images/6.JPG";
import img7 from "../../assets/images/7.JPG";
import img8 from "../../assets/images/8.JPG";
import { trio } from 'ldrs'
import { colors } from "../../assets/config/color";

function Center() {
  trio.register();
  const isSmallScreen = useMediaQuery("(max-width:700px)");
  const [userId, setUserId] = useState();
  const [token, setToken] = useState();
  const [preferedStyles, setPreferedStyles] = useState([]);
  const images = [img1, img2, img3, img4, img5, img6, img7, img8];
  const videos = [video1, video2, video3, video4];
  const [loading, setLoading] = useState(false);

  const fetchData = async (fetchFunction, successCallback, errorMessage) => {
    setLoading(true); // Start loading
    try {
      if (token && userId) {
        const response = await fetchFunction(userId, token);
        if (response.data) {
          successCallback(response.data);
        } else {
          toast.error(response.error);
        }
      } else {
        toast.error("Token or User ID is missing");
      }
    } catch (error) {
      toast.error(errorMessage);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("id");
    toast.error("Session expired. Please log in again.");
    window.location.href = "/";
  };

  const handleBraids = () =>
    fetchData(AuthService.getAllBraids, setPreferedStyles, "Error fetching braids");

  useEffect(() => {
    const tok = localStorage.getItem("token");
    const id = localStorage.getItem("id");
    setToken(tok);
    setUserId(id);
    if (!tok) {
      handleLogout();
    }
  }, []);

  useEffect(() => {
    if (token && userId) {
      handleBraids();
    }
  }, [userId, token]);

  // Sort prefered styles by order count (assuming each style has an 'orderCount' field)
  const sortedStyles = preferedStyles.sort((a, b) => b.orderCount - a.orderCount);
  const topFourStyles = sortedStyles.slice(0, 4);

  const sliderImagesSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    lazyLoad: true,
    dotsClass: "slick-dots slick-thumb",
  };

  const sliderVideosSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 6000,
  };

  return (
    <div className="main-contentH">
      <div className="main-content">
        <div className="padding">
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "50px",
              justifyContent: "space-evenly",
            }}
          >
            <div className="image-carousel">
              <Slider {...sliderImagesSettings}>
                {images.map((img, index) => (
                  <div key={index}>
                    <img
                      src={img}
                      alt={`Style ${index + 1}`}
                      className="carousel-image"
                    />
                  </div>
                ))}
              </Slider>
            </div>
            <div className="video-carousel">
              <Slider {...sliderVideosSettings}>
                {videos.map((vid, index) => (
                  <div key={index}>
                    <video
                      autoplay
                      loop
                      muted
                      controls
                      className="carousel-video"
                      style={{ width: "100%", objectFit: "cover" }}
                    >
                      <source src={vid} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
          <div className="popular-items">
            <h2>Most Ordered Styles</h2>
          </div>

          <div className="rowM" style={{ width: "100%" }}>
            {loading ? (
              <l-trio color={colors.gold}></l-trio>
            ) : topFourStyles.length > 0 ? (
              <BraidsForm
                allBraids={topFourStyles}
                onDishClick={() => null}
              />
            ) : (
              <p>No braids available</p>
            )}
          </div>
        </div>
      </div>

    </div>
  );
}

export default Center;
